function runEmbroideryCustomizer(config) {
                      const sectionId = config.sectionId;
                      const modal = document.querySelector('#EmbroideryModal-' + sectionId + '');
                      if (!modal) return;
                      
                      const embroideryOptionsMetafield = config.embroideryOptionsMetafield;
                      const optionsContainer = modal.querySelector('[data-embroidery-options]');
                      const previewContainer = modal.querySelector('[data-embroidery-preview]');
                      const previewImage = previewContainer?.querySelector('[data-preview-base-image]');
                      const textOverlay = previewContainer?.querySelector('[data-embroidery-text-overlay]');
                      const designOverlay = previewContainer?.querySelector('[data-embroidery-design-overlay]');
                      const addBtn = modal.querySelector('[data-embroidery-add]');
                      const cancelBtn = modal.querySelector('[data-embroidery-cancel]');
                      
                      const embroideryFeeProduct = config.embroideryFeeProduct;
                      const embroideryFeeVariantId = config.embroideryFeeVariantId;
                      
                      if (!embroideryOptionsMetafield || !optionsContainer) return;
                      
                      // Get references to initial and added containers
                      const embroideryContainer = document.querySelector('#ProductEmbroidery-' + sectionId + '');
                      const initialContainer = embroideryContainer?.querySelector('[data-embroidery-options-initial]');
                      const addedContainer = embroideryContainer?.querySelector('[data-embroidery-options-added]');
                      const summaryContainer = embroideryContainer?.querySelector('[data-embroidery-summary]');
                      const clearBtn = embroideryContainer?.querySelector('[data-embroidery-clear]');
                      
                      // Initialize embroidery customizer
                      let selectedType = null;
                      let selectedFont = null;
                      let selectedColor = null;
                      let selectedColorValue = null;
                      let selectedLocation = null;
                      let selectedDesign = null;
                      let selectedDesignImage = null;
                      let selectedMonogramStyle = null;
                      let selectedMonogramStyleImage = null;
                      let enteredText = '';
                      let selectedPawDesignIndex = 0;
                      const previewImages = embroideryOptionsMetafield.previewImages || [];
                      
                      // Function to get current variant color (for preview image matching)
                      // For products with Size + Color, finds the option that matches a preview image name (e.g. color)
                      function getCurrentVariantColor() {
                        const productForm = document.querySelector('#product-form-' + sectionId + '') || document.querySelector('product-form');
                        if (!productForm) return null;
                        
                        const variantIdInput = productForm.querySelector('input[name="id"]');
                        if (!variantIdInput || !variantIdInput.value) return null;
                        
                        const variantId = parseInt(variantIdInput.value);
                        const productData = config.product;
                        
                        if (productData && productData.variants) {
                          const currentVariant = productData.variants.find(v => v.id === variantId);
                          if (currentVariant && currentVariant.options && currentVariant.options.length > 0) {
                            // If we have preview images, find which option value matches a preview (e.g. color name like "Safari")
                            if (previewImages.length > 0) {
                              const previewNames = previewImages.map(p => (p.text || '').trim().toLowerCase());
                              for (let i = 0; i < currentVariant.options.length; i++) {
                                const opt = (currentVariant.options[i] || '').trim().toLowerCase();
                                if (opt && previewNames.some(name => name === opt || name.includes(opt) || opt.includes(name))) {
                                  return currentVariant.options[i];
                                }
                              }
                            }
                            // Fallback: first option (e.g. when only one option or no preview match)
                            return currentVariant.options[0];
                          }
                        }
                        
                        // Fallback: get from form inputs (try option1, then option2, etc. for color match)
                        for (let optNum = 1; optNum <= 3; optNum++) {
                          const inputs = productForm.querySelectorAll(`input[name="option${optNum}"], select[name="option${optNum}"]`);
                          let value = null;
                          if (inputs.length > 0) {
                            const firstInput = inputs[0];
                            if (firstInput.tagName === 'SELECT') {
                              value = firstInput.selectedOptions[0]?.value || firstInput.value;
                            } else {
                              const checked = productForm.querySelector(`input[name="option${optNum}"]:checked`);
                              value = checked ? checked.value : firstInput.value;
                            }
                            if (value && previewImages.length > 0) {
                              const match = previewImages.some(p => (p.text || '').trim().toLowerCase() === (value || '').trim().toLowerCase());
                              if (match) return value;
                            }
                            if (value && optNum === 1) return value;
                          }
                        }
                        return null;
                      }
                      
                      // Function to update preview based on variant color
                      function updatePreviewFromVariant() {
                        if (!previewImage || previewImages.length === 0) return;
                        
                        const variantColor = getCurrentVariantColor();
                        let matchingPreview = null;
                        if (variantColor) {
                          // Find matching preview image by exact text match (case-insensitive)
                          const colorName = variantColor.trim();
                          matchingPreview = previewImages.find(preview => {
                            const previewName = (preview.text || '').trim();
                            return previewName.toLowerCase() === colorName.toLowerCase();
                          }) || null;
                        }
                        // Use matching preview or fall back to first preview image
                        const preview = matchingPreview && matchingPreview.image ? matchingPreview : previewImages[0];
                        if (preview && preview.image) {
                          previewImage.src = preview.image;
                          previewImage.alt = preview.text || '';
                        }
                      }
                      
                      // Helper to check if a type is Hand Scripted Designs
                      function isHandScriptedDesigns(type) {
                        return type && type.text && type.text.toLowerCase().includes('hand scripted');
                      }
                      
                      // Helper to check if a type is Monogram
                      function isMonogram(type) {
                        return type && type.text && type.text.toLowerCase().includes('monogram');
                      }
                      
                      // Helper to check if a type is Sports Package
                      function isSportsPackage(type) {
                        return type && type.text && type.text.toLowerCase().includes('sports package');
                      }

                      function normalizeVariantGroup(value) {
                        return String(value || '').trim().toLowerCase();
                      }

                      function getLocationVariantGroups(location) {
                        if (!location || !Array.isArray(location.variantGroups)) return [];
                        return location.variantGroups.map(normalizeVariantGroup).filter(Boolean);
                      }

                      function getCurrentVariant() {
                        const productForm = document.querySelector('#product-form-' + sectionId + '') || document.querySelector('product-form');
                        const variantIdInput = productForm?.querySelector('input[name="id"]');
                        const variantId = variantIdInput?.value ? parseInt(variantIdInput.value, 10) : null;
                        const productData = config.product;

                        if (productData && productData.variants && variantId) {
                          const currentVariant = productData.variants.find((variant) => variant.id === variantId);
                          if (currentVariant) return currentVariant;
                        }

                        return (productData && productData.variants && productData.variants[0]) || null;
                      }

                      function getCurrentVariantGroups() {
                        const groups = new Set();
                        const currentVariant = getCurrentVariant();

                        if (currentVariant) {
                          (currentVariant.options || []).forEach((value) => {
                            groups.add(normalizeVariantGroup(value));
                          });
                          ['option1', 'option2', 'option3'].forEach((key) => {
                            if (currentVariant[key]) groups.add(normalizeVariantGroup(currentVariant[key]));
                          });
                        }

                        const variantColor = getCurrentVariantColor();
                        if (variantColor) groups.add(normalizeVariantGroup(variantColor));

                        groups.delete('');
                        return groups;
                      }

                      function isLocationAvailable(location) {
                        const requiredGroups = getLocationVariantGroups(location);
                        if (!requiredGroups.length) return true;
                        const currentGroups = getCurrentVariantGroups();
                        return requiredGroups.some((group) => currentGroups.has(group));
                      }

                      function getVisibleLocations(type) {
                        return ((type && type.locations) || []).filter(isLocationAvailable);
                      }
                      
                      // Build the customizer UI from metafield data
                      function buildCustomizer() {
                        if (!embroideryOptionsMetafield.types || embroideryOptionsMetafield.types.length === 0) return;
                        
                        // For now, use the first type (can be extended to support multiple types)
                        const type = embroideryOptionsMetafield.types[0];
                        selectedType = type;
                        const isHandScripted = isHandScriptedDesigns(type);
                        const isMonogramType = isMonogram(type);
                        const isSportsType = isSportsPackage(type);
                        
                        // Reset design selections when not hand scripted or sports package
                        if (!isHandScripted && !isSportsType) {
                          selectedDesign = null;
                          selectedDesignImage = null;
                        }
                        
                        // Reset monogram style when not monogram
                        if (!isMonogramType) {
                          selectedMonogramStyle = null;
                          selectedMonogramStyleImage = null;
                        }
                        
                        let html = '';
                        
                        // Embroidery Type (always show first)
                        const firstType = embroideryOptionsMetafield.types[0];
                        html += '<div class="gift-option" data-embroidery-type>';
                        html += `<h3 class="gift-option__title">EMBROIDERY TYPE: <span class="gift-option__selected-value" data-embroidery-selected-type>${firstType.text}</span></h3>`;
                        html += '<div class="embroidery-type-options">';
                        embroideryOptionsMetafield.types.forEach((typeOption, index) => {
                          const isSelected = index === 0;
                          html += `<label class="embroidery-type-option ${isSelected ? 'selected' : ''}" data-type-index="${index}">`;
                          html += `<input type="radio" name="embroidery_type" value="${typeOption.text}" ${isSelected ? 'checked' : ''} data-type-text="${typeOption.text}">`;
                          if (typeOption.image) {
                            html += `<img src="${typeOption.image}" alt="${typeOption.text}" class="embroidery-type-image">`;
                          }
                          html += '</label>';
                          if (isSelected) selectedType = typeOption;
                        });
                        html += '</div></div>';
                        
                        // Hand Scripted Designs Section (hidden by default, shown when Hand Scripted type selected)
                        const handScriptedType = embroideryOptionsMetafield.types.find(t => isHandScriptedDesigns(t));
                        html += `<div class="gift-option" data-embroidery-designs style="display: ${isHandScripted ? 'block' : 'none'};">`;
                        if (handScriptedType && handScriptedType.designs && handScriptedType.designs.length > 0) {
                          const firstDesign = handScriptedType.designs[0];
                          html += `<h3 class="gift-option__title">HAND SCRIPTED DESIGNS: <span class="gift-option__selected-value" data-embroidery-selected-design>${isHandScripted ? firstDesign.text : ''}</span></h3>`;
                          html += '<div class="embroidery-design-options">';
                          handScriptedType.designs.forEach((design, index) => {
                            const isSelectedDesign = isHandScripted && index === 0;
                            html += `<label class="embroidery-design-option ${isSelectedDesign ? 'selected' : ''}" data-design-index="${index}">`;
                            html += `<input type="radio" name="embroidery_design" value="${design.text}" ${isSelectedDesign ? 'checked' : ''} data-design-text="${design.text}" data-design-image="${design.image || ''}">`;
                            if (design.image) {
                              html += `<img src="${design.image}" alt="${design.text}" class="embroidery-design-image">`;
                            }
                            html += '</label>';
                            if (isSelectedDesign) {
                              selectedDesign = design.text;
                              selectedDesignImage = design.image;
                            }
                          });
                          html += '</div>';
                        }
                        html += '</div>';
                        
                        // Monogram Style Section (hidden by default, shown when Monogram type selected)
                        const monogramType = embroideryOptionsMetafield.types.find(t => isMonogram(t));
                        let selectedMonogramCharLimit = 3; // Default
                        html += `<div class="gift-option" data-embroidery-monogram-style style="display: ${isMonogramType ? 'block' : 'none'};">`;
                        if (monogramType && monogramType.monogramStyles && monogramType.monogramStyles.length > 0) {
                          const firstStyle = monogramType.monogramStyles[0];
                          selectedMonogramCharLimit = firstStyle.characterLimit || 3;
                          html += `<h3 class="gift-option__title">MONOGRAM STYLE: <span class="gift-option__selected-value" data-embroidery-selected-monogram-style>${isMonogramType ? firstStyle.text : ''}</span></h3>`;
                          html += '<div class="embroidery-monogram-style-options">';
                          monogramType.monogramStyles.forEach((style, index) => {
                            const isSelectedStyle = isMonogramType && index === 0;
                            const styleCharLimit = style.characterLimit || 3;
                            html += `<label class="embroidery-monogram-style-option ${isSelectedStyle ? 'selected' : ''}" data-monogram-style-index="${index}">`;
                            html += `<input type="radio" name="embroidery_monogram_style" value="${style.text}" ${isSelectedStyle ? 'checked' : ''} data-monogram-style-text="${style.text}" data-monogram-style-image="${style.image || ''}" data-monogram-char-limit="${styleCharLimit}">`;
                            if (style.image) {
                              html += `<img src="${style.image}" alt="${style.text}" class="embroidery-monogram-style-image">`;
                            }
                            html += '</label>';
                            if (isSelectedStyle) {
                              selectedMonogramStyle = style.text;
                              selectedMonogramStyleImage = style.image;
                            }
                          });
                          html += '</div>';
                        }
                        html += '</div>';
                        
                        // Sports Package Section (hidden by default, shown when Sports Package type selected)
                        const sportsPackageType = embroideryOptionsMetafield.types.find(t => isSportsPackage(t));
                        html += `<div class="gift-option" data-embroidery-sports-package style="display: ${isSportsType ? 'block' : 'none'};">`;
                        if (sportsPackageType && sportsPackageType.designs && sportsPackageType.designs.length > 0) {
                          const firstSportsDesign = sportsPackageType.designs[0];
                          html += `<h3 class="gift-option__title">SPORTS PACKAGE: <span class="gift-option__selected-value" data-embroidery-selected-sports>${isSportsType ? firstSportsDesign.text : ''}</span></h3>`;
                          html += '<div class="embroidery-design-options">';
                          sportsPackageType.designs.forEach((design, index) => {
                            const isSelectedSports = isSportsType && index === 0;
                            html += `<label class="embroidery-design-option ${isSelectedSports ? 'selected' : ''}" data-sports-index="${index}">`;
                            html += `<input type="radio" name="embroidery_sports" value="${design.text}" ${isSelectedSports ? 'checked' : ''} data-sports-text="${design.text}" data-sports-image="${design.image || ''}">`;
                            if (design.image) {
                              html += `<img src="${design.image}" alt="${design.text}" class="embroidery-design-image">`;
                            }
                            html += '</label>';
                            if (isSelectedSports) {
                              selectedDesign = design.text;
                              selectedDesignImage = design.image;
                            }
                          });
                          html += '</div>';
                        }
                        html += '</div>';
                        
                        // Embroidery Location (hidden when Hand Scripted Designs, Monogram, or Sports Package is selected)
                        if (type.locations && type.locations.length > 0) {
                          const hideLocation = isHandScripted || isMonogramType || isSportsType;
                          const firstLocation = type.locations[0];
                          html += `<div class="gift-option" data-embroidery-location style="display: ${hideLocation ? 'none' : 'block'};">`;
                          html += `<h3 class="gift-option__title">LOCATION: <span class="gift-option__selected-value" data-embroidery-selected-location>${firstLocation.text}</span></h3>`;
                          html += '<div class="embroidery-location-options">';
                          type.locations.forEach((location, index) => {
                            html += `<label class="embroidery-location-option" data-location-index="${index}">`;
                            html += `<input type="radio" name="embroidery_location" value="${location.text}" data-location-text="${location.text}">`;
                            if (location.image) {
                              html += `<img src="${location.image}" alt="${location.text}" class="embroidery-location-image">`;
                            }
                            html += '</label>';
                          });
                          html += '</div></div>';
                        }
                        
                        // Font Selection (shown for Monogram, hidden for Hand Scripted and Sports Package)
                        // For Monogram, use fonts from the monogram type
                        const fontsToShow = isMonogramType && monogramType ? monogramType.fonts : (type.fonts || []);
                        const showFonts = (isMonogramType || (!isHandScripted && !isSportsType && type.requiresFontSelection)) && fontsToShow.length > 0;
                        if (fontsToShow.length > 0) {
                          const firstFont = fontsToShow[0];
                          html += `<div class="gift-option" data-embroidery-font style="display: ${showFonts ? 'block' : 'none'};">`;
                          html += `<h3 class="gift-option__title">FONT: <span class="gift-option__selected-value" data-embroidery-selected-font>${firstFont.text}</span></h3>`;
                          html += '<div class="embroidery-font-options">';
                          fontsToShow.forEach((font, index) => {
                            const isSelected = index === 0;
                            html += `<label class="embroidery-font-option ${isSelected ? 'selected' : ''}" data-font-index="${index}">`;
                            html += `<input type="radio" name="embroidery_font" value="${font.text}" ${isSelected ? 'checked' : ''} data-font-text="${font.text}">`;
                            if (font.image) {
                              html += `<img src="${font.image}" alt="${font.text}" class="embroidery-font-image">`;
                            }
                            html += '</label>';
                            if (isSelected && showFonts) selectedFont = font.text;
                          });
                          html += '</div></div>';
                        }
                        
                        // Font Color Selection (hidden for Sports Package)
                        if (type.threadColors && type.threadColors.length > 0) {
                          const hideColor = isSportsType;
                          html += `<div class="gift-option" data-embroidery-color style="display: ${hideColor ? 'none' : 'block'};">`;
                          const firstColor = type.threadColors[0];
                          html += `<h3 class="gift-option__title">FONT COLOR: <span class="gift-option__selected-color" data-embroidery-selected-color>${firstColor.text}</span></h3>`;
                          html += '<div class="embroidery-color-options">';
                          type.threadColors.forEach((color, index) => {
                            const isSelected = index === 0;
                            html += `<label class="embroidery-color-option ${isSelected ? 'selected' : ''}" data-color-index="${index}">`;
                            html += `<input type="radio" name="embroidery_color" value="${color.text}" ${isSelected ? 'checked' : ''} data-color-text="${color.text}" data-color-value="${color.value}">`;
                            html += `<span class="embroidery-color-swatch" style="background-color: ${color.value};"></span>`;
                            html += '</label>';
                            if (isSelected && !hideColor) {
                              selectedColor = color.text;
                              selectedColorValue = color.value;
                            }
                          });
                          html += '</div></div>';
                        }
                        
                        // Paw Design options (from type.pawDesigns when type.requiresPawDesignSelection)
                        if (type.requiresPawDesignSelection && type.pawDesigns && type.pawDesigns.length > 0) {
                          const firstPaw = type.pawDesigns[0];
                          html += '<div class="gift-option" data-embroidery-paw-design>';
                          html += '<h3 class="gift-option__title">PAW DESIGN: <span class="gift-option__selected-value" data-embroidery-selected-paw>' + (firstPaw.text || 'No Paw Design') + '</span></h3>';
                          html += '<div class="embroidery-paw-options">';
                          type.pawDesigns.forEach(function(paw, idx) {
                            const isSelected = idx === 0;
                            const variantId = paw.variantId || '';
                            if (isSelected) selectedPawDesignIndex = idx;
                            html += '<label class="embroidery-paw-option' + (isSelected ? ' selected' : '') + '" data-paw-index="' + idx + '">';
                            html += '<input type="radio" name="embroidery_paw" value="' + (paw.text || '').replace(/"/g, '&quot;') + '" ' + (isSelected ? 'checked' : '') + ' data-paw-variant-id="' + variantId + '" data-paw-index="' + idx + '">';
                            html += '<span class="embroidery-paw-label">' + (paw.text || '') + '</span>';
                            html += '<span class="embroidery-paw-visual-wrap">';
                            if (idx === 0 && !paw.image) {
                              html += '<span class="embroidery-paw-visual embroidery-paw-visual--empty" aria-hidden="true"></span>';
                            } else if (paw.image) {
                              html += '<img src="' + paw.image + '" alt="' + (paw.text || '').replace(/"/g, '&quot;') + '" class="embroidery-paw-visual embroidery-paw-image">';
                            } else {
                              html += '<span class="embroidery-paw-visual embroidery-paw-icon" aria-hidden="true">🐾</span>';
                            }
                            html += '</span>';
                            html += '</label>';
                          });
                          html += '</div></div>';
                        }
                        
                        // Text Input (hidden when Hand Scripted Designs, Monogram, or Sports Package is selected)
                        if (type.textInput) {
                          const hideTextInput = isHandScripted || isMonogramType || isSportsType;
                          html += `<div class="gift-option" data-embroidery-text style="display: ${hideTextInput ? 'none' : 'flex'};">`;
                          html += '<h3 class="gift-option__title">ENTER CASE SENSITIVE</br>NAME/TEXT:</h3>';
                          const characterLimit = type.characterLimit || 15;
                          // Apply initial font if available
                          const initialFontFamily = selectedFont ? getFontFamily(selectedFont) : '';
                          const fontStyle = initialFontFamily ? `style="font-family: ${initialFontFamily};"` : '';
                          html += `<input type="text" class="embroidery-text-input" name="embroidery_text" data-embroidery-text-input maxlength="${characterLimit}" placeholder="Enter text..." ${fontStyle}>`;
                          html += `<div class="embroidery-character-count"><span data-char-count>0</span>/${characterLimit} characters</div>`;
                          html += '</div>';
                        }
                        
                        // Monogram Initials Input (shown only for Monogram type)
                        // Use the character limit from the selected monogram style
                        html += `<div class="gift-option" data-embroidery-monogram-text style="display: ${isMonogramType ? 'block' : 'none'};">`;
                        html += `<h3 class="gift-option__title">MONOGRAM INITIAL(S)</h3>`;
                        const monogramFontFamily = selectedFont ? getFontFamily(selectedFont) : '';
                        const monogramFontStyle = monogramFontFamily ? `style="font-family: ${monogramFontFamily};"` : '';
                        html += `<input type="text" class="embroidery-text-input embroidery-monogram-input" name="embroidery_monogram_text" data-embroidery-monogram-input maxlength="${selectedMonogramCharLimit}" placeholder="Enter initials..." ${monogramFontStyle}>`;
                        html += '</div>';
                        
                        optionsContainer.innerHTML = html;
                        
                        // Add event listeners
                        setupEventListeners();
                        syncLocationOptions();
                        updateAddButtonState();
                        updateDesignOverlay();
                      }

                      function getLocationsSource() {
                        if (selectedType && selectedType.locations && selectedType.locations.length) {
                          return selectedType.locations;
                        }
                        const firstType = embroideryOptionsMetafield.types && embroideryOptionsMetafield.types[0];
                        return (firstType && firstType.locations) || [];
                      }

                      function syncLocationOptions() {
                        const locationSection = optionsContainer.querySelector('[data-embroidery-location]');
                        if (!locationSection) return;

                        const typeHidesLocation =
                          isHandScriptedDesigns(selectedType) ||
                          isMonogram(selectedType) ||
                          isSportsPackage(selectedType);
                        const locations = getLocationsSource();
                        const labels = locationSection.querySelectorAll('[data-location-index]');
                        let firstVisibleInput = null;
                        let visibleCount = 0;
                        let selectedStillVisible = false;

                        labels.forEach((label) => {
                          const index = parseInt(label.dataset.locationIndex, 10);
                          const location = locations[index];
                          const available = isLocationAvailable(location);
                          const input = label.querySelector('input[name="embroidery_location"]');

                          label.hidden = !available;
                          label.style.display = available ? '' : 'none';
                          if (input) input.disabled = !available;

                          if (available) {
                            visibleCount += 1;
                            if (!firstVisibleInput && input) firstVisibleInput = input;
                            if (input && (input.checked || selectedLocation === input.dataset.locationText)) {
                              selectedStillVisible = true;
                            }
                          } else if (input && input.checked) {
                            input.checked = false;
                            label.classList.remove('selected');
                          }
                        });

                        if (typeHidesLocation || visibleCount === 0) {
                          locationSection.style.display = 'none';
                          if (!typeHidesLocation) selectedLocation = null;
                          updateLocationOptions();
                          updateAddButtonState();
                          updateTextOverlay();
                          return;
                        }

                        locationSection.style.display = 'block';

                        if (!selectedStillVisible && firstVisibleInput) {
                          firstVisibleInput.checked = true;
                          selectedLocation = firstVisibleInput.dataset.locationText;
                        } else if (selectedStillVisible && !optionsContainer.querySelector('input[name="embroidery_location"]:checked') && firstVisibleInput) {
                          firstVisibleInput.checked = true;
                          selectedLocation = firstVisibleInput.dataset.locationText;
                        }

                        const selectedLocationDisplay = optionsContainer.querySelector('[data-embroidery-selected-location]');
                        if (selectedLocationDisplay) {
                          selectedLocationDisplay.textContent = selectedLocation || '';
                        }

                        updateLocationOptions();
                        updateAddButtonState();
                        updateTextOverlay();
                      }
                      
                      function setupEventListeners() {
                        // Location selection
                        const locationInputs = optionsContainer.querySelectorAll('input[name="embroidery_location"]');
                        locationInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            selectedLocation = this.dataset.locationText;
                            
                            // Update the title to show selected location
                            const selectedLocationDisplay = optionsContainer.querySelector('[data-embroidery-selected-location]');
                            if (selectedLocationDisplay) {
                              selectedLocationDisplay.textContent = selectedLocation;
                            }
                            
                            updateAddButtonState();
                            updateLocationOptions();
                            updateTextOverlay();
                          });
                        });
                        
                        // Type selection
                        const typeInputs = optionsContainer.querySelectorAll('input[name="embroidery_type"]');
                        typeInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            const typeIndex = parseInt(this.closest('[data-type-index]').dataset.typeIndex);
                            selectedType = embroideryOptionsMetafield.types[typeIndex];
                            
                            // Update the title to show selected type
                            const selectedTypeDisplay = optionsContainer.querySelector('[data-embroidery-selected-type]');
                            if (selectedTypeDisplay) {
                              selectedTypeDisplay.textContent = selectedType.text;
                            }
                            
                            // Check type
                            const isHandScripted = isHandScriptedDesigns(selectedType);
                            const isMonogramType = isMonogram(selectedType);
                            const isSportsType = isSportsPackage(selectedType);
                            
                            // Show/hide relevant sections based on type
                            const locationSection = optionsContainer.querySelector('[data-embroidery-location]');
                            const fontSection = optionsContainer.querySelector('[data-embroidery-font]');
                            const colorSection = optionsContainer.querySelector('[data-embroidery-color]');
                            const textSection = optionsContainer.querySelector('[data-embroidery-text]');
                            const designsSection = optionsContainer.querySelector('[data-embroidery-designs]');
                            const monogramStyleSection = optionsContainer.querySelector('[data-embroidery-monogram-style]');
                            const monogramTextSection = optionsContainer.querySelector('[data-embroidery-monogram-text]');
                            const sportsPackageSection = optionsContainer.querySelector('[data-embroidery-sports-package]');
                            
                            if (isHandScripted) {
                              // Hide location, font, text, monogram, sports sections; show designs and color
                              if (locationSection) locationSection.style.display = 'none';
                              if (fontSection) fontSection.style.display = 'none';
                              if (colorSection) colorSection.style.display = 'block';
                              if (textSection) textSection.style.display = 'none';
                              if (monogramStyleSection) monogramStyleSection.style.display = 'none';
                              if (monogramTextSection) monogramTextSection.style.display = 'none';
                              if (sportsPackageSection) sportsPackageSection.style.display = 'none';
                              if (designsSection) designsSection.style.display = 'block';
                              
                              // Clear text/location/font/monogram values
                              selectedLocation = null;
                              selectedFont = null;
                              enteredText = '';
                              selectedMonogramStyle = null;
                              selectedMonogramStyleImage = null;
                              
                              // Set first design as selected if available
                              const handScriptedType = embroideryOptionsMetafield.types.find(t => isHandScriptedDesigns(t));
                              if (handScriptedType && handScriptedType.designs && handScriptedType.designs.length > 0) {
                                const firstDesignInput = optionsContainer.querySelector('input[name="embroidery_design"]');
                                if (firstDesignInput && !firstDesignInput.checked) {
                                  firstDesignInput.checked = true;
                                  selectedDesign = handScriptedType.designs[0].text;
                                  selectedDesignImage = handScriptedType.designs[0].image;
                                  const designLabel = firstDesignInput.closest('.embroidery-design-option');
                                  if (designLabel) designLabel.classList.add('selected');
                                  
                                  // Update design title display
                                  const selectedDesignDisplay = optionsContainer.querySelector('[data-embroidery-selected-design]');
                                  if (selectedDesignDisplay) {
                                    selectedDesignDisplay.textContent = selectedDesign;
                                  }
                                }
                              }
                              
                              // Sync design from DOM so preview shows after toggling back from Monogram (which clears these)
                              const checkedDesignInput = optionsContainer.querySelector('input[name="embroidery_design"]:checked');
                              if (checkedDesignInput) {
                                selectedDesign = checkedDesignInput.dataset.designText || selectedDesign;
                                selectedDesignImage = checkedDesignInput.dataset.designImage || selectedDesignImage;
                              }
                              
                              // Sync color from DOM so preview shows after toggling from another type
                              const checkedColorInputHand = optionsContainer.querySelector('input[name="embroidery_color"]:checked');
                              if (checkedColorInputHand) {
                                selectedColor = checkedColorInputHand.dataset.colorText || null;
                                selectedColorValue = checkedColorInputHand.dataset.colorValue || null;
                              }
                              
                              // Update overlays
                              updateTextOverlay();
                              updateDesignOverlay();
                            } else if (isSportsType) {
                              // Hide location, font, color, text, monogram, designs sections; show sports package
                              if (locationSection) locationSection.style.display = 'none';
                              if (fontSection) fontSection.style.display = 'none';
                              if (colorSection) colorSection.style.display = 'none';
                              if (textSection) textSection.style.display = 'none';
                              if (monogramStyleSection) monogramStyleSection.style.display = 'none';
                              if (monogramTextSection) monogramTextSection.style.display = 'none';
                              if (designsSection) designsSection.style.display = 'none';
                              if (sportsPackageSection) sportsPackageSection.style.display = 'block';
                              
                              // Clear text/location/font/monogram/color values
                              selectedLocation = null;
                              selectedFont = null;
                              selectedColor = null;
                              selectedColorValue = null;
                              enteredText = '';
                              selectedMonogramStyle = null;
                              selectedMonogramStyleImage = null;
                              
                              // Set first sports design as selected if available
                              const sportsType = embroideryOptionsMetafield.types.find(t => isSportsPackage(t));
                              if (sportsType && sportsType.designs && sportsType.designs.length > 0) {
                                const firstSportsInput = optionsContainer.querySelector('input[name="embroidery_sports"]');
                                if (firstSportsInput && !firstSportsInput.checked) {
                                  firstSportsInput.checked = true;
                                  selectedDesign = sportsType.designs[0].text;
                                  selectedDesignImage = sportsType.designs[0].image;
                                  const sportsLabel = firstSportsInput.closest('.embroidery-design-option');
                                  if (sportsLabel) sportsLabel.classList.add('selected');
                                  
                                  // Update sports design title display
                                  const selectedSportsDisplay = optionsContainer.querySelector('[data-embroidery-selected-sports]');
                                  if (selectedSportsDisplay) {
                                    selectedSportsDisplay.textContent = selectedDesign;
                                  }
                                }
                              }
                              
                              // Sync sports design from DOM so preview shows after toggling back from Monogram (which clears these)
                              const checkedSportsInput = optionsContainer.querySelector('input[name="embroidery_sports"]:checked');
                              if (checkedSportsInput) {
                                selectedDesign = checkedSportsInput.dataset.sportsText || selectedDesign;
                                selectedDesignImage = checkedSportsInput.dataset.sportsImage || selectedDesignImage;
                              }
                              
                              // Update overlays
                              updateTextOverlay();
                              updateDesignOverlay();
                            } else if (isMonogramType) {
                              // Show monogram style, font, color, monogram text; hide others
                              if (locationSection) locationSection.style.display = 'none';
                              if (fontSection) fontSection.style.display = 'block';
                              if (colorSection) colorSection.style.display = 'block';
                              if (textSection) textSection.style.display = 'none';
                              if (designsSection) designsSection.style.display = 'none';
                              if (sportsPackageSection) sportsPackageSection.style.display = 'none';
                              if (monogramStyleSection) monogramStyleSection.style.display = 'block';
                              if (monogramTextSection) monogramTextSection.style.display = 'block';
                              
                              // Clear design/location values
                              selectedDesign = null;
                              selectedDesignImage = null;
                              selectedLocation = null;
                              enteredText = '';
                              
                              // Set first monogram style as selected if available
                              const monogramType = embroideryOptionsMetafield.types.find(t => isMonogram(t));
                              if (monogramType && monogramType.monogramStyles && monogramType.monogramStyles.length > 0) {
                                const firstStyleInput = optionsContainer.querySelector('input[name="embroidery_monogram_style"]');
                                if (firstStyleInput && !firstStyleInput.checked) {
                                  firstStyleInput.checked = true;
                                  selectedMonogramStyle = monogramType.monogramStyles[0].text;
                                  selectedMonogramStyleImage = monogramType.monogramStyles[0].image;
                                  const styleLabel = firstStyleInput.closest('.embroidery-monogram-style-option');
                                  if (styleLabel) styleLabel.classList.add('selected');
                                  
                                  // Update monogram style title display
                                  const selectedStyleDisplay = optionsContainer.querySelector('[data-embroidery-selected-monogram-style]');
                                  if (selectedStyleDisplay) {
                                    selectedStyleDisplay.textContent = selectedMonogramStyle;
                                  }
                                }
                              }
                              
                              // Sync monogram style from DOM so preview shows after toggling back from Sports (which clears these)
                              const checkedMonogramStyleInput = optionsContainer.querySelector('input[name="embroidery_monogram_style"]:checked');
                              if (checkedMonogramStyleInput) {
                                selectedMonogramStyle = checkedMonogramStyleInput.dataset.monogramStyleText || selectedMonogramStyle;
                                selectedMonogramStyleImage = checkedMonogramStyleInput.dataset.monogramStyleImage || selectedMonogramStyleImage;
                              }
                              
                              // Sync color from DOM so preview shows after toggling from another type
                              const checkedColorInput = optionsContainer.querySelector('input[name="embroidery_color"]:checked');
                              if (checkedColorInput) {
                                selectedColor = checkedColorInput.dataset.colorText || null;
                                selectedColorValue = checkedColorInput.dataset.colorValue || null;
                              }
                              
                              // Update overlays
                              updateTextOverlay();
                              updateDesignOverlay();
                            } else {
                              // Show location, font, color, and text sections; hide monogram, designs, and sports
                              if (locationSection) locationSection.style.display = 'block';
                              if (fontSection) fontSection.style.display = 'block';
                              if (colorSection) colorSection.style.display = 'block';
                              if (textSection) textSection.style.display = 'block';
                              if (designsSection) designsSection.style.display = 'none';
                              if (sportsPackageSection) sportsPackageSection.style.display = 'none';
                              if (monogramStyleSection) monogramStyleSection.style.display = 'none';
                              if (monogramTextSection) monogramTextSection.style.display = 'none';
                              
                              // Clear design/monogram values
                              selectedDesign = null;
                              selectedDesignImage = null;
                              selectedMonogramStyle = null;
                              selectedMonogramStyleImage = null;
                              
                              syncLocationOptions();
                              
                              // Sync text, color, and font from DOM so preview shows after toggling back from Hand Scripted (which clears enteredText)
                              const textInputBasic = optionsContainer.querySelector('[data-embroidery-text-input]');
                              if (textInputBasic) {
                                enteredText = textInputBasic.value || '';
                              }
                              const checkedColorInputBasic = optionsContainer.querySelector('input[name="embroidery_color"]:checked');
                              if (checkedColorInputBasic) {
                                selectedColor = checkedColorInputBasic.dataset.colorText || null;
                                selectedColorValue = checkedColorInputBasic.dataset.colorValue || null;
                              }
                              const checkedFontInputBasic = optionsContainer.querySelector('input[name="embroidery_font"]:checked');
                              if (checkedFontInputBasic) {
                                selectedFont = checkedFontInputBasic.dataset.fontText || selectedFont;
                              }
                              
                              // Update overlays
                              updateTextOverlay();
                              updateDesignOverlay();
                            }
                            
                            rebuildFontAndColorOptions();
                            updateAddButtonState();
                            updateTypeOptions();
                          });
                        });
                        
                        // Design selection (for Hand Scripted Designs)
                        const designInputs = optionsContainer.querySelectorAll('input[name="embroidery_design"]');
                        designInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            selectedDesign = this.dataset.designText;
                            selectedDesignImage = this.dataset.designImage;
                            
                            // Update the title to show selected design
                            const selectedDesignDisplay = optionsContainer.querySelector('[data-embroidery-selected-design]');
                            if (selectedDesignDisplay) {
                              selectedDesignDisplay.textContent = selectedDesign;
                            }
                            
                            updateAddButtonState();
                            updateDesignOptions();
                            updateDesignOverlay();
                          });
                        });
                        
                        // Sports Package selection
                        const sportsInputs = optionsContainer.querySelectorAll('input[name="embroidery_sports"]');
                        sportsInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            selectedDesign = this.dataset.sportsText;
                            selectedDesignImage = this.dataset.sportsImage;
                            
                            // Update the title to show selected sports design
                            const selectedSportsDisplay = optionsContainer.querySelector('[data-embroidery-selected-sports]');
                            if (selectedSportsDisplay) {
                              selectedSportsDisplay.textContent = selectedDesign;
                            }
                            
                            updateAddButtonState();
                            updateSportsOptions();
                            updateDesignOverlay();
                          });
                        });
                        
                        // Monogram style selection
                        const monogramStyleInputs = optionsContainer.querySelectorAll('input[name="embroidery_monogram_style"]');
                        monogramStyleInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            selectedMonogramStyle = this.dataset.monogramStyleText;
                            selectedMonogramStyleImage = this.dataset.monogramStyleImage;
                            
                            // Update the title to show selected style
                            const selectedStyleDisplay = optionsContainer.querySelector('[data-embroidery-selected-monogram-style]');
                            if (selectedStyleDisplay) {
                              selectedStyleDisplay.textContent = selectedMonogramStyle;
                            }
                            
                            // Update the monogram input's character limit based on selected style
                            const charLimit = parseInt(this.dataset.monogramCharLimit) || 3;
                            const monogramInput = optionsContainer.querySelector('[data-embroidery-monogram-input]');
                            if (monogramInput) {
                              monogramInput.maxLength = charLimit;
                              // Truncate existing text if it exceeds the new limit
                              if (monogramInput.value.length > charLimit) {
                                monogramInput.value = monogramInput.value.substring(0, charLimit);
                                enteredText = monogramInput.value;
                              }
                            }
                            
                            updateAddButtonState();
                            updateMonogramStyleOptions();
                            updateDesignOverlay(); // Update preview with selected monogram style
                          });
                        });
                        
                        // Monogram text input
                        const monogramTextInput = optionsContainer.querySelector('[data-embroidery-monogram-input]');
                        if (monogramTextInput) {
                          monogramTextInput.addEventListener('input', function() {
                            enteredText = this.value;
                            updateAddButtonState();
                            updateTextOverlay();
                          });
                        }
                        
                        // Font selection
                        const fontInputs = optionsContainer.querySelectorAll('input[name="embroidery_font"]');
                        fontInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            selectedFont = this.dataset.fontText;
                            
                            // Update the title to show selected font
                            const selectedFontDisplay = optionsContainer.querySelector('[data-embroidery-selected-font]');
                            if (selectedFontDisplay) {
                              selectedFontDisplay.textContent = selectedFont;
                            }
                            
                            // Apply font to text input and overlay
                            applySelectedFont();
                            
                            updateAddButtonState();
                            updateFontOptions();
                          });
                        });
                        
                        // Color selection
                        const colorInputs = optionsContainer.querySelectorAll('input[name="embroidery_color"]');
                        colorInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            selectedColor = this.dataset.colorText;
                            const colorValue = this.dataset.colorValue;
                            if (colorValue) {
                              selectedColorValue = colorValue;
                            }
                            
                            // Update the title to show selected color
                            const selectedColorDisplay = optionsContainer.querySelector('[data-embroidery-selected-color]');
                            if (selectedColorDisplay) {
                              selectedColorDisplay.textContent = selectedColor;
                            }
                            
                            updateAddButtonState();
                            updateColorOptions();
                            updatePreviewImage();
                            updateTextOverlay();
                            updateDesignOverlay(); // Update design color when font color changes
                          });
                        });
                        
                        // Paw design selection
                        const pawInputs = optionsContainer.querySelectorAll('input[name="embroidery_paw"]');
                        pawInputs.forEach(input => {
                          input.addEventListener('change', function() {
                            selectedPawDesignIndex = parseInt(this.dataset.pawIndex, 10) || 0;
                            const selectedPawDisplay = optionsContainer.querySelector('[data-embroidery-selected-paw]');
                            if (selectedPawDisplay) selectedPawDisplay.textContent = this.value || 'No Paw Design';
                            optionsContainer.querySelectorAll('.embroidery-paw-option').forEach(label => {
                              label.classList.toggle('selected', label.querySelector('input[name="embroidery_paw"]') === input);
                            });
                            updateAddButtonState();
                          });
                        });
                        
                        // Text input
                        const textInput = optionsContainer.querySelector('[data-embroidery-text-input]');
                        if (textInput) {
                          textInput.addEventListener('input', function() {
                            enteredText = this.value;
                            const charCount = this.value.length;
                            const charCountDisplay = optionsContainer.querySelector('[data-char-count]');
                            if (charCountDisplay) {
                              charCountDisplay.textContent = charCount;
                            }
                            updateAddButtonState();
                            updateTextOverlay();
                          });
                        }
                      }
                      
                      function rebuildFontAndColorOptions() {
                        if (!selectedType) return;
                        
                        const isSportsType = isSportsPackage(selectedType);
                        
                        // Rebuild font options (for non-Hand Scripted and non-Sports types that have fonts)
                        const fontContainer = optionsContainer.querySelector('[data-embroidery-font]');
                        const shouldRebuildFonts = !isHandScriptedDesigns(selectedType) && 
                                                   !isSportsType &&
                                                   selectedType.fonts && 
                                                   selectedType.fonts.length > 0 &&
                                                   (selectedType.requiresFontSelection || isMonogram(selectedType));
                        
                        if (fontContainer && shouldRebuildFonts) {
                          const firstFont = selectedType.fonts[0];
                          let fontHtml = `<h3 class="gift-option__title">FONT: <span class="gift-option__selected-value" data-embroidery-selected-font>${firstFont.text}</span></h3>`;
                          fontHtml += '<div class="embroidery-font-options">';
                          selectedType.fonts.forEach((font, index) => {
                            const isSelected = index === 0;
                            fontHtml += `<label class="embroidery-font-option ${isSelected ? 'selected' : ''}" data-font-index="${index}">`;
                            fontHtml += `<input type="radio" name="embroidery_font" value="${font.text}" ${isSelected ? 'checked' : ''} data-font-text="${font.text}">`;
                            if (font.image) {
                              fontHtml += `<img src="${font.image}" alt="${font.text}" class="embroidery-font-image">`;
                            }
                            fontHtml += '</label>';
                            if (isSelected) selectedFont = font.text;
                          });
                          fontHtml += '</div>';
                          fontContainer.innerHTML = fontHtml;
                        }
                        
                        // Rebuild color options from the currently selected type (skip for Sports Package)
                        const colorContainer = optionsContainer.querySelector('[data-embroidery-color]');
                        if (colorContainer && !isSportsType && selectedType.threadColors && selectedType.threadColors.length > 0) {
                          const firstColor = selectedType.threadColors[0];
                          let colorHtml = `<h3 class="gift-option__title">FONT COLOR: <span class="gift-option__selected-color" data-embroidery-selected-color>${firstColor.text}</span></h3>`;
                          colorHtml += '<div class="embroidery-color-options">';
                          selectedType.threadColors.forEach((color, index) => {
                            const isSelected = index === 0;
                            colorHtml += `<label class="embroidery-color-option ${isSelected ? 'selected' : ''}" data-color-index="${index}">`;
                            colorHtml += `<input type="radio" name="embroidery_color" value="${color.text}" ${isSelected ? 'checked' : ''} data-color-text="${color.text}" data-color-value="${color.value}">`;
                            colorHtml += `<span class="embroidery-color-swatch" style="background-color: ${color.value};"></span>`;
                            colorHtml += '</label>';
                            if (isSelected) {
                              selectedColor = color.text;
                              selectedColorValue = color.value;
                            }
                          });
                          colorHtml += '</div>';
                          colorContainer.innerHTML = colorHtml;
                        }
                        
                        // Re-setup event listeners after rebuilding
                        setupEventListeners();
                        
                        // Re-apply font after rebuilding
                        applySelectedFont();
                        
                        // Update design overlay (for Hand Scripted Designs, Monogram, and Sports Package)
                        if (isHandScriptedDesigns(selectedType) || isMonogram(selectedType) || isSportsType) {
                          updateDesignOverlay();
                        }
                      }
                      
                      function updateLocationOptions() {
                        const labels = optionsContainer.querySelectorAll('[data-location-index]');
                        labels.forEach(label => {
                          const input = label.querySelector('input[type="radio"]');
                          if (input && input.checked) {
                            label.classList.add('selected');
                          } else {
                            label.classList.remove('selected');
                          }
                        });
                      }
                      
                      function updateTypeOptions() {
                        const labels = optionsContainer.querySelectorAll('[data-type-index]');
                        labels.forEach(label => {
                          const input = label.querySelector('input[type="radio"]');
                          if (input && input.checked) {
                            label.classList.add('selected');
                          } else {
                            label.classList.remove('selected');
                          }
                        });
                      }
                      
                      function updateFontOptions() {
                        const labels = optionsContainer.querySelectorAll('[data-font-index]');
                        labels.forEach(label => {
                          const input = label.querySelector('input[type="radio"]');
                          if (input && input.checked) {
                            label.classList.add('selected');
                          } else {
                            label.classList.remove('selected');
                          }
                        });
                      }
                      
                      function updateColorOptions() {
                        const labels = optionsContainer.querySelectorAll('[data-color-index]');
                        labels.forEach(label => {
                          const input = label.querySelector('input[type="radio"]');
                          if (input && input.checked) {
                            label.classList.add('selected');
                          } else {
                            label.classList.remove('selected');
                          }
                        });
                      }
                      
                      function updateDesignOptions() {
                        const labels = optionsContainer.querySelectorAll('[data-design-index]');
                        labels.forEach(label => {
                          const input = label.querySelector('input[type="radio"]');
                          if (input && input.checked) {
                            label.classList.add('selected');
                          } else {
                            label.classList.remove('selected');
                          }
                        });
                      }
                      
                      function updateSportsOptions() {
                        const labels = optionsContainer.querySelectorAll('[data-sports-index]');
                        labels.forEach(label => {
                          const input = label.querySelector('input[type="radio"]');
                          if (input && input.checked) {
                            label.classList.add('selected');
                          } else {
                            label.classList.remove('selected');
                          }
                        });
                      }
                      
                      function updateMonogramStyleOptions() {
                        const labels = optionsContainer.querySelectorAll('[data-monogram-style-index]');
                        labels.forEach(label => {
                          const input = label.querySelector('input[type="radio"]');
                          if (input && input.checked) {
                            label.classList.add('selected');
                          } else {
                            label.classList.remove('selected');
                          }
                        });
                      }
                      
                      // Parse color to RGB values
                      function parseColor(color) {
                        if (!color) return { r: 0, g: 0, b: 0 };
                        
                        let r, g, b;
                        if (color.startsWith('#')) {
                          const hex = color.slice(1);
                          if (hex.length === 3) {
                            r = parseInt(hex[0] + hex[0], 16);
                            g = parseInt(hex[1] + hex[1], 16);
                            b = parseInt(hex[2] + hex[2], 16);
                          } else {
                            r = parseInt(hex.slice(0, 2), 16);
                            g = parseInt(hex.slice(2, 4), 16);
                            b = parseInt(hex.slice(4, 6), 16);
                          }
                        } else if (color.startsWith('rgb')) {
                          const match = color.match(/\d+/g);
                          if (match) {
                            r = parseInt(match[0]);
                            g = parseInt(match[1]);
                            b = parseInt(match[2]);
                          }
                        }
                        
                        return { r: r || 0, g: g || 0, b: b || 0 };
                      }
                      
                      function updateDesignOverlay() {
                        if (!designOverlay) return;
                        
                        // Clear existing content
                        designOverlay.innerHTML = '';
                        designOverlay.style.display = 'none';
                        designOverlay.removeAttribute('data-preview-mode');
                        
                        // Determine which image to show (Hand Scripted design, Monogram style, or Sports Package)
                        const isHandScripted = isHandScriptedDesigns(selectedType);
                        const isMonogramType = isMonogram(selectedType);
                        const isSportsType = isSportsPackage(selectedType);
                        
                        if (isHandScripted) designOverlay.setAttribute('data-preview-mode', 'hand-scripted');
                        else if (isMonogramType) designOverlay.setAttribute('data-preview-mode', 'monogram');
                        else if (isSportsType) designOverlay.setAttribute('data-preview-mode', 'sports');
                        
                        let imageToShow = null;
                        let altText = '';
                        
                        if (isHandScripted) {
                          imageToShow = selectedDesignImage;
                          altText = selectedDesign || 'Selected Design';
                        } else if (isSportsType) {
                          imageToShow = selectedDesignImage;
                          altText = selectedDesign || 'Selected Sports Design';
                        } else if (isMonogramType) {
                          imageToShow = selectedMonogramStyleImage;
                          altText = selectedMonogramStyle || 'Selected Monogram Style';
                        }
                        
                        // Show design overlay based on type
                        if (imageToShow) {
                          // Sports Package: Display image in original colors (no color filter)
                          if (isSportsType) {
                            const img = document.createElement('img');
                            img.src = imageToShow;
                            img.alt = altText;
                            img.className = 'embroidery-preview__design-image';
                            img.style.width = '100%';
                            img.style.height = 'auto';
                            
                            designOverlay.appendChild(img);
                            designOverlay.style.display = 'flex';
                            
                            // Hide text overlay when showing sports design
                            if (textOverlay) {
                              textOverlay.style.display = 'none';
                            }
                          } 
                          // Hand Scripted and Monogram: Apply color filter (or fallback from DOM/default)
                          else if (isHandScripted || isMonogramType) {
                            let colorValue = selectedColorValue;
                            if (!colorValue && optionsContainer) {
                              const checkedColor = optionsContainer.querySelector('input[name="embroidery_color"]:checked');
                              if (checkedColor && checkedColor.dataset.colorValue) {
                                colorValue = checkedColor.dataset.colorValue;
                              }
                            }
                            if (!colorValue) colorValue = '#333333';
                            const color = parseColor(colorValue);
                            const r = color.r / 255;
                            const g = color.g / 255;
                            const b = color.b / 255;
                            
                            // Create unique filter ID
                            const filterId = 'colorize-filter-' + Date.now();
                            
                            // Create SVG with color matrix filter
                            const svgNS = 'http://www.w3.org/2000/svg';
                            const svg = document.createElementNS(svgNS, 'svg');
                            svg.setAttribute('width', '0');
                            svg.setAttribute('height', '0');
                            svg.style.position = 'absolute';
                            
                            const defs = document.createElementNS(svgNS, 'defs');
                            const filter = document.createElementNS(svgNS, 'filter');
                            filter.setAttribute('id', filterId);
                            filter.setAttribute('color-interpolation-filters', 'sRGB');
                            
                            // Color matrix to convert image to target color
                            const colorMatrix = document.createElementNS(svgNS, 'feColorMatrix');
                            colorMatrix.setAttribute('type', 'matrix');
                            colorMatrix.setAttribute('values', `
                              0 0 0 0 ${r}
                              0 0 0 0 ${g}
                              0 0 0 0 ${b}
                              0 0 0 1 0
                            `);
                            
                            filter.appendChild(colorMatrix);
                            defs.appendChild(filter);
                            svg.appendChild(defs);
                            designOverlay.appendChild(svg);
                            
                            const img = document.createElement('img');
                            img.src = imageToShow;
                            img.alt = altText;
                            img.className = 'embroidery-preview__design-image';
                            img.style.width = '100%';
                            img.style.height = 'auto';
                            img.style.filter = `url(#${filterId})`;
                            
                            designOverlay.appendChild(img);
                            designOverlay.style.display = 'flex';
                            
                            if (textOverlay) {
                              textOverlay.style.display = 'none';
                            }
                          }
                        } else {
                          // Show text overlay when not in design/monogram/sports mode
                          if (textOverlay) {
                            textOverlay.style.display = 'flex';
                          }
                        }
                      }
                      
                      function updatePreviewImage() {
                        // Always try to update based on variant color first
                        updatePreviewFromVariant();
                        
                        // If no variant match, try thread color as fallback
                        if (!previewImage || !selectedColor || previewImages.length === 0) return;
                        
                        // Only use thread color if variant didn't match
                        const variantColor = getCurrentVariantColor();
                        if (!variantColor) {
                          // Find matching preview image by thread color name
                          const matchingPreview = previewImages.find(preview => {
                            const previewName = (preview.text || '').toLowerCase();
                            const selectedColorLower = selectedColor.toLowerCase();
                            return previewName === selectedColorLower || previewName.includes(selectedColorLower) || selectedColorLower.includes(previewName);
                          });
                          const preview = (matchingPreview && matchingPreview.image) ? matchingPreview : previewImages[0];
                          if (preview && preview.image) {
                            previewImage.src = preview.image;
                            previewImage.alt = preview.text || '';
                          }
                        }
                      }
                      
                      function getFontFamily(fontName) {
                        // Map font names to CSS font-family values
                        // You may need to adjust these based on your actual font setup
                        const fontMap = {
                          'Sanford': "'Sanford', serif",
                          'Yellosun': "'Yellosun', serif",
                          'Aubrey': "'Aubrey', serif",
                          'Bebas - This is in all caps': "'Bebas Neue', sans-serif",
                          'Century Gothic': "'Century Gothic', sans-serif",
                          'Dearly Loved One': "'Dearly Loved One', serif",
                          'Segoe Print': "'Segoe Print', serif"
                        };
                        
                        // Return mapped font or use the font name directly
                        return fontMap[fontName] || `'${fontName}', serif`;
                      }
                      
                      function applySelectedFont() {
                        if (!selectedFont) return;
                        
                        const fontFamily = getFontFamily(selectedFont);
                        
                        // Apply font to text input
                        const textInput = optionsContainer.querySelector('[data-embroidery-text-input]');
                        if (textInput) {
                          textInput.style.fontFamily = fontFamily;
                        }
                        
                        // Apply font to monogram input
                        const monogramInput = optionsContainer.querySelector('[data-embroidery-monogram-input]');
                        if (monogramInput) {
                          monogramInput.style.fontFamily = fontFamily;
                        }
                        
                        // Apply font to text overlay
                        if (textOverlay) {
                          textOverlay.style.fontFamily = fontFamily;
                        }
                      }
                      
                      function updateAddButtonState() {
                        if (!addBtn) return;
                        
                        let isValid = true;
                        
                        // Check if type is selected
                        if (!selectedType) isValid = false;
                        
                        // Check if Hand Scripted Designs type is selected
                        if (isHandScriptedDesigns(selectedType)) {
                          // For Hand Scripted Designs, we need a design and color selected
                          if (!selectedDesign) isValid = false;
                          if (!selectedColor) isValid = false;
                        } else if (isSportsPackage(selectedType)) {
                          // For Sports Package, we only need a design selected (no color/font/text)
                          if (!selectedDesign) isValid = false;
                        } else if (isMonogram(selectedType)) {
                          // For Monogram, we need monogram style, font, color, and initials
                          if (!selectedMonogramStyle) isValid = false;
                          if (!selectedFont) isValid = false;
                          if (!selectedColor) isValid = false;
                          if (!enteredText.trim()) isValid = false;
                        } else {
                          // For regular embroidery types
                          // Check if font is required and selected
                          if (selectedType && selectedType.requiresFontSelection && !selectedFont) {
                            isValid = false;
                          }
                          
                          // Check if color is selected
                          if (!selectedColor) isValid = false;
                          
                          // Check if location is selected when any locations are available
                          if (getVisibleLocations(selectedType).length > 0 && !selectedLocation) isValid = false;
                          
                          // Check if text is entered (if textInput is true)
                          if (selectedType && selectedType.textInput && !enteredText.trim()) {
                            isValid = false;
                          }
                        }
                        
                        addBtn.disabled = !isValid;
                      }
                      
                      function updateTextOverlay() {
                        if (!textOverlay) return;
                        
                        // Clear existing content
                        textOverlay.textContent = '';
                        textOverlay.removeAttribute('data-location');
                        
                        // If text is entered and color is selected, display it
                        if (enteredText && selectedColorValue) {
                          textOverlay.textContent = enteredText;
                          textOverlay.style.color = selectedColorValue;
                          
                          // Apply selected font
                          if (selectedFont) {
                            const fontFamily = getFontFamily(selectedFont);
                            textOverlay.style.fontFamily = fontFamily;
                          }
                          
                          // Set location attribute for positioning
                          if (selectedLocation) {
                            textOverlay.setAttribute('data-location', selectedLocation);
                          }
                        } else {
                          textOverlay.textContent = '';
                          textOverlay.style.color = '';
                        }
                      }
                      
                      // Cancel button
                      if (cancelBtn) {
                        cancelBtn.addEventListener('click', function() {
                          modal.removeAttribute('open');
                          document.body.classList.remove('overflow-hidden');
                        });
                      }
                      
                      // Add button
                      if (addBtn) {
                        addBtn.addEventListener('click', function() {
                          const isHandScripted = isHandScriptedDesigns(selectedType);
                          const isMonogramType = isMonogram(selectedType);
                          const isSportsType = isSportsPackage(selectedType);
                          
                          var pawDesignLabel = '';
                          var pawDesignVariantId = null;
                          if (selectedType && selectedType.pawDesigns && selectedType.pawDesigns.length > 0) {
                            var pawOpt = selectedType.pawDesigns[selectedPawDesignIndex];
                            pawDesignLabel = (pawOpt && pawOpt.text) ? pawOpt.text : 'No Paw Design';
                            if (selectedPawDesignIndex > 0) {
                              pawDesignVariantId = (pawOpt && pawOpt.variantId) ? String(pawOpt.variantId) : (config.pawFeeVariantId ? String(config.pawFeeVariantId) : '42919495893191');
                            }
                          }
                          const embroideryData = {
                            type: selectedType ? selectedType.text : '',
                            font: (isMonogramType || (!isHandScripted && !isSportsType && selectedFont)) ? (selectedFont || '') : '',
                            color: (isHandScripted || isMonogramType) ? (selectedColor || '') : (isSportsType ? '' : (selectedColor || '')),
                            location: (isHandScripted || isMonogramType || isSportsType) ? '' : (selectedLocation || ''),
                            text: isMonogramType ? (enteredText || '') : ((isHandScripted || isSportsType) ? '' : (enteredText || '')),
                            design: (isHandScripted || isSportsType) ? (selectedDesign || '') : '',
                            monogramStyle: isMonogramType ? (selectedMonogramStyle || '') : '',
                            pawDesignLabel: pawDesignLabel,
                            pawDesignVariantId: pawDesignVariantId
                          };
                          
                          // Generate a unique embroidery ID to link the product and fee
                          const embroideryId = 'EMB-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
                          
                          // Save to product form
                          const form = document.querySelector('#product-form-' + sectionId + '') || 
                                       document.querySelector('product-form')?.querySelector('form');
                          
                          if (form) {
                            // Remove old embroidery ID inputs (hidden _-prefixed + visible + legacy)
                            form
                              .querySelectorAll(
                                'input[name="properties[_Embroidery ID]"], input[name="properties[embroideryID]"], input[name="properties[Embroidery ID]"]'
                              )
                              .forEach((input) => input.remove());

                            [
                              'properties[_Embroidery ID]',
                              'properties[embroideryID]',
                            ].forEach((name) => {
                              const embroideryIdInput = document.createElement('input');
                              embroideryIdInput.type = 'hidden';
                              embroideryIdInput.name = name;
                              embroideryIdInput.value = embroideryId;
                              form.appendChild(embroideryIdInput);
                            });
                          }
                          
                          // Update the display to show added state (fee will be added when product is added to cart)
                          displayEmbroideryAdded(embroideryData, embroideryId);
                          
                          // Close modal
                          modal.removeAttribute('open');
                          document.body.classList.remove('overflow-hidden');
                        });
                      }
                      
                      // Function to display the embroidery added state
                      function displayEmbroideryAdded(embroideryData, embroideryId) {
                        if (!initialContainer || !addedContainer || !summaryContainer) return;
                        
                        // Hide initial, show added
                        initialContainer.style.display = 'none';
                        addedContainer.style.display = 'block';
                        
                        // Store embroidery data for re-adding to cart
                        const embroideryPayload = {
                          ...embroideryData,
                          embroideryId: embroideryId,
                          feeVariantId: embroideryFeeVariantId,
                          productTitle: config.productTitle
                        };
                        addedContainer.setAttribute('data-embroidery-data', JSON.stringify(embroideryPayload));
                        
                        // Build summary HTML
                        let summaryHtml = '';
                        
                        if (embroideryData.type) {
                          summaryHtml += `<p class="gift-options__summary-item"><strong>Embroidery Type:</strong> ${embroideryData.type}</p>`;
                        }
                        if (embroideryData.location) {
                          summaryHtml += `<p class="gift-options__summary-item"><strong>Location:</strong> ${embroideryData.location}</p>`;
                        }
                        if (embroideryData.font) {
                          summaryHtml += `<p class="gift-options__summary-item"><strong>Font:</strong> ${embroideryData.font}</p>`;
                        }
                        if (embroideryData.monogramStyle) {
                          summaryHtml += `<p class="gift-options__summary-item"><strong>Monogram Style:</strong> ${embroideryData.monogramStyle}</p>`;
                        }
                        if (embroideryData.color) {
                          summaryHtml += `<p class="gift-options__summary-item"><strong>Font Color:</strong> ${embroideryData.color}</p>`;
                        }
                        if (embroideryData.design) {
                          // Determine the label based on the type
                          const isHandScripted = embroideryData.type && embroideryData.type.toLowerCase().includes('hand scripted');
                          const isSportsType = embroideryData.type && embroideryData.type.toLowerCase().includes('sports package');
                          let designLabel = 'Design';
                          if (isHandScripted) {
                            designLabel = 'Hand Scripted Design';
                          } else if (isSportsType) {
                            designLabel = 'Sports Design';
                          }
                          summaryHtml += `<p class="gift-options__summary-item"><strong>${designLabel}:</strong> ${embroideryData.design}</p>`;
                        }
                        if (embroideryData.text) {
                          summaryHtml += `<p class="gift-options__summary-item"><strong>Text:</strong> ${embroideryData.text}</p>`;
                        }
                        if (selectedType && selectedType.pawDesigns && selectedType.pawDesigns.length > 0) {
                          var pawOpt = selectedType.pawDesigns[selectedPawDesignIndex];
                          var pawLabel = (pawOpt && pawOpt.text) ? pawOpt.text : 'No Paw Design';
                          summaryHtml += '<p class="gift-options__summary-item"><strong>Paw Design:</strong> ' + pawLabel + '</p>';
                        }
                        
                        summaryContainer.innerHTML = summaryHtml;
                      }
                      
                      // Function to clear embroidery and show initial state
                      function clearEmbroidery() {
                        if (!initialContainer || !addedContainer) return;
                        
                        // Show initial, hide added
                        initialContainer.style.display = 'block';
                        addedContainer.style.display = 'none';
                        
                        // Clear form inputs
                        const form = document.querySelector('#product-form-' + sectionId + '') || 
                                     document.querySelector('product-form')?.querySelector('form');
                        if (form) {
                          // Remove embroidery ID from main product
                          form
                            .querySelectorAll(
                              'input[name="properties[_Embroidery ID]"], input[name="properties[embroideryID]"], input[name="properties[Embroidery ID]"]'
                            )
                            .forEach((input) => input.remove());
                        }
                        
                        // Reset selections
                        selectedType = embroideryOptionsMetafield.types ? embroideryOptionsMetafield.types[0] : null;
                        selectedFont = null;
                        selectedColor = null;
                        selectedColorValue = null;
                        selectedLocation = null;
                        selectedDesign = null;
                        selectedDesignImage = null;
                        selectedMonogramStyle = null;
                        selectedMonogramStyleImage = null;
                        enteredText = '';
                        selectedPawDesignIndex = 0;
                        
                        // Rebuild customizer
                        buildCustomizer();
                      }
                      
                      // Clear button handler
                      if (clearBtn) {
                        clearBtn.addEventListener('click', clearEmbroidery);
                      }
                      
                        // Initialize
                        buildCustomizer();
                        
                        // Apply initial font
                        applySelectedFont();
                        
                        // Initialize text overlay
                        updateTextOverlay();
                        
                        // Function to update preview when modal opens
                        function updatePreviewOnModalOpen() {
                          // Small delay to ensure variant is fully loaded
                          setTimeout(() => {
                            updatePreviewFromVariant();
                            syncLocationOptions();
                            applySelectedFont();
                            updateTextOverlay();
                            updateDesignOverlay();
                          }, 100);
                        }
                        
                        // Listen for modal opening
                        const observer = new MutationObserver(function(mutations) {
                          mutations.forEach(function(mutation) {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                              if (modal.hasAttribute('open')) {
                                updatePreviewOnModalOpen();
                              }
                            }
                          });
                        });
                        observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
                        
                        // Listen for modal opening via custom event or attribute change
                        document.body.addEventListener('modalOpened', function() {
                          updatePreviewOnModalOpen();
                        });
                        
                        // Always set initial preview image (will update when modal opens)
                        updatePreviewOnModalOpen();
                        
                        // Listen for variant changes (all options: size, color, etc.)
                        const productForm = document.querySelector('#product-form-' + sectionId + '') || document.querySelector('product-form');
                        if (productForm) {
                          ['option1', 'option2', 'option3'].forEach(optionName => {
                            const variantInputs = productForm.querySelectorAll(`input[name="${optionName}"], select[name="${optionName}"]`);
                            variantInputs.forEach(input => {
                              input.addEventListener('change', function() {
                                setTimeout(() => {
                                  updatePreviewFromVariant();
                                  syncLocationOptions();
                                }, 150);
                              });
                            });
                          });
                          
                          // Also listen for changes on the variant ID input (when variant changes)
                          const variantIdInput = productForm.querySelector('input[name="id"]');
                          if (variantIdInput) {
                            const refreshFromVariant = () => {
                              updatePreviewFromVariant();
                              syncLocationOptions();
                            };
                            variantIdInput.addEventListener('change', refreshFromVariant);
                            const variantObserver = new MutationObserver(() => {
                              if (modal.hasAttribute('open')) {
                                refreshFromVariant();
                              }
                            });
                            variantObserver.observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
                          }
                        }
                        
                        // Listen for variant-selects changes
                        const variantSelects = document.querySelector('variant-selects');
                        if (variantSelects) {
                          variantSelects.addEventListener('change', function(e) {
                            if (e.target.name && (e.target.name.startsWith('option') || e.target.name.startsWith('options['))) {
                              setTimeout(() => {
                                updatePreviewFromVariant();
                                syncLocationOptions();
                              }, 150);
                            }
                          });
                        }
}
(function bootstrap() {
  var configs = window.__embroideryConfigs || [];
  window.__embroideryConfigs = [];
  function run() {
    configs.forEach(runEmbroideryCustomizer);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
